import api from '@/composables/useApiFactory'
import type { LeaderboardEntryT, SchoolT } from '@/types/User'

const MiscellaneousService = {
  async getLeaderboard() {
    return api().get<LeaderboardEntryT[]>(`/users/leaderboard/`)
  },

  async getAllSchools() {
    return api().get<SchoolT[]>(`/schools/`)
  }
}

export default MiscellaneousService
